/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import React, { useEffect } from "react";
import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import { AuthPage, useAuth } from "../auth";
import { ErrorPage } from "../features/ErrorPage";
import App from "../App";
import { PrivateRoutes } from "./PrivateRoutes";
import { Otpverification } from "../auth/signup/verfictions/Otpverification";
import { Verifysuccess } from "../auth/signup/verfictions/Verifysuccess";
import { Login } from "../auth/login/Login";
import { OtpverificationError } from "../auth/signup/verfictions/OtpverificationError";
import { MobileOtpVerification } from "../auth/signup/verfictions/MobileOtpVerification";
import { Otpdevice } from "../auth/signup/verfictions/Otpdevice";
import { ChooseAddress } from "../component/ChooseAddress";
import { ForgotPasswordUserData } from "../auth/signup/verfictions/ForgotPasswordUserData";
import ThankYouPage from "../component/ThankYouPage";
import SalesPage from "../modules/subscription/files/SalesPage";
import SalesPagePromoteKit from "../modules/subscription/files/SalesPagePromoteKit";
import PromokitSuccess from "../modules/subscription/files/PromokitSuccess";
import PromokitCancel from "../modules/subscription/files/PromokitCancel";

function AppRoutes() {
  const { currentUser } = useAuth();
  useEffect(() => {
    const currentPath = window.location.pathname;
    if (currentPath.includes("sales-page")) {
      localStorage.setItem("isSalesPage", "true");
      localStorage.setItem("redirectUrl", currentPath + window.location.search);
    } else {
      localStorage.setItem("isSalesPage", "false");
    }
  }, []);

  let redirect = "auth";
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<App />}>
          <Route path="error/*" element={<ErrorPage />} />

          {currentUser ? (
            <>
              <Route path="/*" element={<PrivateRoutes />} />
              <Route index element={<Navigate to={redirect} />} />
            </>
          ) : (
            <>

              <Route path="auth/*" element={<AuthPage />} />
              <Route path="*" element={<Navigate to="/auth" />} />
              <Route path="otp-verification" element={<Otpverification />} />
              <Route path="otp-device" element={<Otpdevice />} />
              <Route
                path="otp-verification-mobile"
                element={<MobileOtpVerification />}
              />
              <Route path="otpVerifyError" element={<OtpverificationError />} />
              <Route path="otp-success" element={<Verifysuccess />} />{" "}
              <Route path="login" element={<Login />} />

              <Route path="choose-address" element={<ChooseAddress />} />
              <Route
                path="forgot-password"
                element={<ForgotPasswordUserData />}
              />
              {/* Check if user is trying to access sales-page */}
              {/* <Route
                path="sales-page"
                element={currentUser ? <PlanSelection /> : <Navigate to="/auth" />}
              /> */}
              <Route path="thankyou-page" element={<ThankYouPage />} />
              <Route path="sales-page" element={<SalesPage />} />
              <Route path="sales-page-promotekit/" element={<SalesPagePromoteKit />} />
              <Route path="success-promotekit" element={<PromokitSuccess />} />
              <Route path="cancel-promotekit" element={<PromokitCancel />} />
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default AppRoutes;